// api/offer_api.js

import { buildUrl, formatParam } from "../util/integration"

import {
    authorizedFetch,
} from "./http_api";

export const fetchAvailableOffersAPI = (
    accessToken,
    userId,
) => {
    return authorizedFetch(
        accessToken,
        buildUrl(
            "offer/available"
            + "?userId="
            + formatParam(userId),
        ),
        {
            method: "GET",
        },
    );
};

export const fetchOfferAPI = (
    accessToken,
    offerId,
    userId
) => {
    return authorizedFetch(
        accessToken,
        buildUrl(
            "offer/"
            + formatParam(offerId) 
            + "?userId="
            + formatParam(userId),
        ),
        {
            method: "GET",
        },
    );
};

export const buyOfferAPI = (
    accessToken,
    offerId,
    buyerId,
) => {
    return authorizedFetch(
        accessToken,
        buildUrl(
            "offer/"
            + formatParam(offerId)
            + "/purchase"
            + "?buyerId="
            + formatParam(buyerId),
        ),
        {
            method: "PUT",
        },
    );
};

export const abortOfferAPI = (
    accessToken,
    offerId,
) => {
    return authorizedFetch(
        accessToken,
        buildUrl(
            "offer/"
            + formatParam(offerId)
            + "/abortion",
        ),
        {
            method: "DELETE",
        },
    );
};